import { useRef, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import emailjs from 'emailjs-com'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

const CareersForm = () => {
    // Form state
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [designation, setDesignation] = useState('')
    const [description, setDescription] = useState('')

    // Error states
    const [nameError, setNameError] = useState('')
    const [emailError, setEmailError] = useState('')
    const [phoneError, setPhoneError] = useState('')
    const [designationError, setDesignationError] = useState('')

    // Captcha states
    const [verified, setVerified] = useState(false)
    const [captchaError, setCaptchaError] = useState('')

    function onChange(value) {
        console.log('Captcha value:', value)
        setVerified(!!value)
        setCaptchaError('')
    }

    // Name validation - only letters and min 3 characters
    const validateName = (value) => {
        const nameRegex = /^[A-Za-z\s]+$/
        if (!value) {
            setNameError('Name is required')
            return false
        } else if (value.length < 3) {
            setNameError('Name must be at least 3 characters')
            return false
        } else if (!nameRegex.test(value)) {
            setNameError('Name should contain only letters')
            return false
        } else {
            setNameError('')
            return true
        }
    }

    // Email validation
    const validateEmail = (value) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!value) {
            setEmailError('Email is required')
            return false
        } else if (!emailRegex.test(value)) {
            setEmailError('Please enter a valid email address')
            return false
        } else {
            setEmailError('')
            return true
        }
    }

    // Phone validation
    const validatePhone = (value) => {
        if (!value) {
            setPhoneError('Phone number is required')
            return false
        } else {
            setPhoneError('')
            return true
        }
    }

    // Designation validation
    const validateDesignation = (value) => {
        if (!value) {
            setDesignationError('Designation is required')
            return false
        } else {
            setDesignationError('')
            return true
        }
    }

    // Handle field blur events for validation
    const handleNameBlur = () => validateName(name)
    const handleEmailBlur = () => validateEmail(email)
    const handlePhoneBlur = () => validatePhone(phone)
    const handleDesignationBlur = () => validateDesignation(designation)

    const refform = useRef()
    const sendForm = (e) => {
        e.preventDefault()

        // Validate all fields before submission
        const isNameValid = validateName(name)
        const isEmailValid = validateEmail(email)
        const isPhoneValid = validatePhone(phone)
        const isDesignationValid = validateDesignation(designation)

        // Check captcha
        if (!verified) {
            setCaptchaError('Please verify that you are not a robot')
            return
        }

        // If all validations pass, submit the form
        if (isNameValid && isEmailValid && isPhoneValid && isDesignationValid) {
            emailjs
                .sendForm('service_52cv4u2', '800homes2', e.target, 'qLyy-QK10bQA32qAQ')
                .then((res) => {
                    console.log(res)
                    window.alert('Form Submitted')
                    // Reset form
                    setName('')
                    setEmail('')
                    setPhone('')
                    setDesignation('')
                    setDescription('')
                    e.target.reset()
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    }

    return (
        <>
            <section id="website-responsive" className="container-fluid bg-grey-2 rounded-0 px-0">
                <div className="row justify-content-center align-items-center">
                    <div className="col-12">
                        {/* <div className='fs-ss-30 fw-500 lh-sm text-white' >
                  Careers
                </div> */}
                        <h2 className="fs-ss-30 text-white fw-300 pb-4">
                            Join a Team That Invests in Your Success. Grow, Achieve, and Excel with Us.
                        </h2>
                        <div className="">
                            <form
                                ref={refform}
                                onSubmit={sendForm}
                                id="contactForm"
                                method="POST"
                                action="#"
                                className=""
                            >
                                <div className="form-group mb-3">
                                    <input
                                        type="text"
                                        className={`form-control text-grey fs-ss-16 fw-300 ${
                                            nameError ? 'is-invalid' : ''
                                        }`}
                                        id="name"
                                        name="name"
                                        placeholder="Name *"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        onBlur={handleNameBlur}
                                        required
                                    />
                                    {nameError && <div className="invalid-feedback">{nameError}</div>}
                                </div>
                                <div className="form-group mb-3">
                                    <input
                                        type="email"
                                        className={`form-control text-grey fs-ss-16 fw-300 ${
                                            emailError ? 'is-invalid' : ''
                                        }`}
                                        id="email"
                                        name="email"
                                        placeholder="Email *"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        onBlur={handleEmailBlur}
                                        required
                                    />
                                    {emailError && <div className="invalid-feedback">{emailError}</div>}
                                </div>
                                <div className="form-group mb-3">
                                    <PhoneInput
                                        country={'ae'}
                                        value={phone}
                                        onChange={(phone) => setPhone(phone)}
                                        onBlur={handlePhoneBlur}
                                        inputProps={{
                                            name: 'phone_number',
                                            id: 'phone_number',
                                            required: true,
                                            className: `w-100 bg-transparent rounded-0 border-bottom border-0 border-white text-grey fs-ss-16 fw-300 ps-5 ${
                                                phoneError ? 'is-invalid' : ''
                                            }`,
                                            placeholder: 'Phone Number *',
                                        }}
                                        containerStyle={{
                                            width: '100%',
                                        }}
                                        enableSearch={true}
                                        buttonStyle={{
                                            backgroundColor: 'transparent',
                                            border: 'none',
                                        }}
                                        dropdownStyle={{
                                            width: '300px',
                                        }}
                                    />
                                    {phoneError && <div className="invalid-feedback d-block">{phoneError}</div>}
                                </div>
                                <div className="form-group mb-3">
                                    <input
                                        type="text"
                                        className={`form-control text-grey fs-ss-16 fw-300 ${
                                            designationError ? 'is-invalid' : ''
                                        }`}
                                        id="designation"
                                        name="designation"
                                        placeholder="Designation *"
                                        value={designation}
                                        onChange={(e) => setDesignation(e.target.value)}
                                        onBlur={handleDesignationBlur}
                                        required
                                    />
                                    {designationError && <div className="invalid-feedback">{designationError}</div>}
                                </div>
                                {/* <div id="cv" className="form-group mb-3">
        <label type="file" className="text-grey fs-ss-16 fw-300"> Upload CV </label>
        <input type="file" className="form-control text-grey fs-ss-16 fw-300" id="cv" />
      </div> */}
                                <div className="form-group mb-4">
                                    <textarea
                                        className="form-control text-grey fs-ss-16 fw-300"
                                        id="description"
                                        name="description"
                                        rows="4"
                                        placeholder="Description"
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                    ></textarea>
                                </div>
                                <div className="">
                                    <ReCAPTCHA sitekey="6LdX3UgqAAAAAMWqmjHfeiVGKr_oLcfyYrNEu8KH" onChange={onChange} />
                                    {captchaError && <div className="text-danger mb-2">{captchaError}</div>}
                                    <button className="mt-4 text-center text-white fw-300 bg-ss-primary bg-hover-ss-primary rounded-0 border-0 text-ss-secondary fs-ss-16 px-3 py-ss-2 w-100">
                                        Submit
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default CareersForm
